import { useRead, usePut } from '@spotify-internal/creator-data-loading';
import { artistProfileLoader } from '../../artistProfileLoader';
import { useCurrentArtist } from '../../../artists';

export function useOptimisticUpdate() {
  const artist = useCurrentArtist();

  const artistProfile = useRead(artistProfileLoader, artist.id);
  const setArtistProfile = usePut(artistProfileLoader, artist.id);

  return function optimisticUpdate({
    channel,
    url,
  }: {
    channel: string;
    url: string;
  }) {
    if (artistProfile) {
      setArtistProfile({
        ...artistProfile,
        artistFundraisingPick: { channel, url },
      });
    }
  };
}
